import { z } from 'zod';

export const paymentSchema = z.object({
  _ptxn: z.string().optional(),
  billed: z.string().optional(),
  plan: z.string().optional(),
  token: z.string().optional()
});
